import { Collection } from "../../domain/Collection";

import { UserGroup } from "../../domain/UserGroup";
import { useServicesContext } from "../../providers/ServicesProvider";
import { ALL_PAGES_SIZE, SWR_KEY_PREFIX } from "../../constants/constants";
import useSWR from "swr";

export const useOrgUserGroups = ({
    groupTypes,
    organizationId,
    roleIds,
    skip
}: {
    groupTypes?: string[];
    organizationId?: string;
    roleIds?: string[];
    skip?: boolean;
}) => {
    const { userService } = useServicesContext();

    // get an SWR key based on the parameters passed in. if the parameters are not passed in they shouldn't be included in the key
    let key =
        organizationId && !skip
            ? `${SWR_KEY_PREFIX.GROUPS}/api/usergroups/${organizationId}?size=${ALL_PAGES_SIZE}`
            : null;
    if (groupTypes?.length && key) {
        key = `${key}&groupTypes=${groupTypes.join(",")}`;
    }
    if (roleIds?.length && key) {
        key = `${key}&roleIds=${roleIds.join(",")}`;
    }

    const { data, error, mutate } = useSWR<Collection<UserGroup>, Error>(key, () => {
        if (skip) {
            return Promise.resolve({ items: [] } as unknown as Collection<UserGroup>);
        }
        return userService.getUserGroups({
            organizationId: organizationId as string,
            groupTypes,
            roleIds,
            size: ALL_PAGES_SIZE
        });
    });

    return {
        userGroups: data?.items,
        isLoading: !error && !data,
        error,
        revalidate: mutate
    };
};
